import React from "react";
import awsp from "../assets/AWSP.png";
import awsdevop from "../assets/AWDevOp.png";
import awsecurity from "../assets/AWSecurity.png";
import kubernetes from "../assets/kubernetes.png";
/*import terraform from "../assets/terraform.png"
import azureAdmin from "../assets/azureAdmin.png"
import gcp from "../assets/gcp-clound-enginer.png"
*/
const Certification = () => {
  const certifications = [
    {
      id: 1,
      src: awsp,
      url: "https://www.credly.com/badges/8e402085-b4fc-4770-8df1-adcf09656d9c/public_url",
      title: "AWS Certified Solutions Architect",
      description: "Professional-level certification for designing distributed systems on AWS",
      style: "shadow-cyan-500",
    },
    {
      id: 2,
      src: awsdevop,
      url: "https://www.credly.com/badges/b8f3935c-9674-4867-99ae-8cad22f05e73/public_url",
      title: "AWS Certified DevOps Engineer",
      description: "Expertise in provisioning, operating, and managing distributed systems",
      style: "shadow-cyan-500",
    },
    {
      id: 3,
      src: awsecurity,
      url: "https://www.credly.com/badges/8eff8532-3eca-4789-878f-188f7cbf1da2/public_url",
      title: "AWS Certified Security",
      description: "Specialized knowledge in securing AWS workloads and applications",
      style: "shadow-violet-700",
    },
    {
      id: 4,
      src: kubernetes,
      url: "https://www.credly.com/badges/e134abec-8a17-4b5a-a07b-c8e89e27a31e/public_url",
      title: "Kubernetes Administrator",
      description: "Certified in container orchestration and Kubernetes cluster management",
      style: "shadow-blue-800",
    }/*,
    {
      id: 4,
      src: awsdev,
      url: "https://www.credly.com/badges/863f0d32-553d-4504-9c43-1b35d36713a7/public_url",
      style: "shadow-blue-700",
    },
    {
      id: 5,
      src: awssystem,
      url: "https://www.credly.com/badges/658c3596-1389-44ba-85f1-76c53b49e9d5/public_url",
      style: "shadow-blue-700",
    },{
      id: 7,
      src: awssa,
      url: "https://www.credly.com/badges/b81043cb-2230-44c1-bf46-e7ec9b2ea795/public_url",
      style: "shadow-blue-700",
    },{
      id: 8,
      src: terraform,
      url: "https://www.credly.com/badges/b81043cb-2230-44c1-bf46-e7ec9b2ea795/public_url",
      style: "shadow-violet-500",
    },{
      id: 7,
      src: azureAdmin,
      url: "https://www.credly.com/badges/b81043cb-2230-44c1-bf46-e7ec9b2ea795/public_url",
      style: "shadow-blue-700",
    },{
      id: 8,
      src: gcp,
      url: "https://www.credly.com/badges/b81043cb-2230-44c1-bf46-e7ec9b2ea795/public_url",
      style: "shadow-gray-200",
    }*/
    
  ];
  return (
    <div
      name="certification"
      className="bg-gradient-to-b from-gray-950 via-zinc-900 to-slate-950 w-full text-white py-6 md:py-8 lg:py-10"
    >
      <div className="max-w-screen-lg mx-auto px-6 md:px-8">
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-1 w-12 bg-blue-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">
            Certification
            </h3>
          </div>
          <p className="text-gray-300 text-sm md:text-base lg:text-lg font-light tracking-wide">
            View my certifications
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-3 sm:gap-5 md:gap-6">
          {certifications.map(({ id, src, url, title, description, style }) => (
            <a 
              key={id}
              href={url} 
              target="_blank" 
              rel="noreferrer"
              className="group"
            >
              <div className={`bg-gray-900/40 hover:bg-gray-800/50 rounded-lg p-3 sm:p-4 md:p-5 border border-gray-700/40 hover:border-blue-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20 backdrop-blur-sm ${style}`}>
                <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                  {/* Small Icon */}
                  <div className="flex-shrink-0 mx-auto sm:mx-0">
                <img
                  src={src}
                      alt={title}
                      className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 object-contain group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 min-w-0 text-center sm:text-left">
                    <h4 className="text-sm sm:text-base md:text-lg font-bold text-white mb-1.5 sm:mb-2 group-hover:text-blue-400 transition-colors tracking-tight">
                      {title}
                    </h4>
                    <p className="text-xs sm:text-sm md:text-base text-gray-300 leading-relaxed font-light tracking-wide">
                      {description}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Certification;
